module.exports = __webpack_public_path__ + "img/gb9115_9.prt.61ae2b7b.jpg";